import { Component, OnInit, Output, Input, EventEmitter, OnDestroy } from '@angular/core';
import { ModalSize } from './modal.model';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss']
,  standalone: false
})
export class ModalComponent implements OnInit, OnDestroy {

    @Input() modalText: string = "";
    @Input() modalSize: ModalSize = ModalSize.Medium;
    @Input() hidePopUp: boolean;
    @Input() isDraggable: boolean = true;
    @Input() resize: boolean = false;
    @Output() modalClose: EventEmitter<boolean> = new EventEmitter();


    modalClasses: string = "";
    name: string;
    //hidePopUp: boolean = false;


    ngOnInit() { 
        this.configureModal();
    }
    
    configureModal() {

        switch (this.modalSize) {
            case ModalSize.Small: this.modalClasses = this.modalClasses.concat(" small");
                break;
            case ModalSize.Medium: this.modalClasses = this.modalClasses.concat(" medium");
                break;
            case ModalSize.Large: this.modalClasses = this.modalClasses.concat(" large");
                break;
            case ModalSize.ExtraLarge: this.modalClasses = this.modalClasses.concat(" extralarge");
                break;
            case ModalSize.FitContent: this.modalClasses = this.modalClasses.concat(" fitContent");
                break;
            case ModalSize.CustomSignaturePopup: this.modalClasses = this.modalClasses.concat(" custom-signature-popup-modal");
                break;
            case ModalSize.CustomConsentPopup: this.modalClasses = this.modalClasses.concat(" custom-consent-popup-modal");
                break;
            default:
                this.modalClasses = " small";
        }
    }
    closePopUp() {
        this.modalClose.emit(true);
    }
    ngOnDestroy() {
        this.modalClose.unsubscribe();
}
}
